module.exports = __webpack_public_path__ + "img/icon-record.e2c2799c.svg";